
<v-card
    :ripple = "false"
    flat
    rounded
>
    <div
        class = "lm-border pa-3 pt-3"
        style = "position: relative"
    >
        <div
            class = "v-flex"
            style = "justify-content: space-between; height: 22px"
        >
            <div style="font-size: 15px; padding-top: 1px;" class="v-flex">
                <div class="primary--text">
                    {{ site.fabricNo }}
                </div>
            </div>
            <v-spacer/>
            <div class="site-customer">
               {{ site.customer.name }}
            </div>
            <div style="margin-top: -2px; margin-right: -7px;">
                <c-site-icon
                    :site="site"
                />
            </div>
        </div>
        <v-divider class="mt-1 mb-1" />
        <div class="card-subtitle">
            {{ site.street }}, {{ site.zip }} {{ site.city }}
        </div>
        <div class="card-subtitle">
            {{ site.ve }}  {{ site.ve && site.ve2 ? ' / ' : ''  }}  {{ site.ve2 }}
        </div>
    </div>
</v-card>
